import React from 'react';
import { X, Check, TrendingUp } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

// P5: contextual Premium marketing modal (NOT a hard paywall). Shown to Free
// merchants at high-intent moments (requesting a payout, a large payment). Presents the Premium value prop and an optional
// computed savings line, then routes to billing on upgrade.
const VALUE_PROPS = [
  '1% transaction fee (down from 2%)',
  'Lower payout minimums',
  'Priority payouts — faster settlement SLAs',
  'Advanced analytics & scheduled reports',
];

const PremiumUpsellModal = ({ onClose, savings, context }) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    onClose?.();
    navigate('/dashboard/billing');
  };

  const showSavings = typeof savings === 'number' && isFinite(savings) && savings > 0;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal premium-upsell-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Upgrade to Premium</h2>
          <button className="close-btn" onClick={onClose} aria-label="Close">
            <X size={20} />
          </button>
        </div>

        <div className="modal-body">
          {context && <p className="premium-upsell-lead">{context}</p>}

          <ul className="premium-upsell-feats">
            {VALUE_PROPS.map((f) => (
              <li key={f}><Check size={15} /> {f}</li>
            ))}
          </ul>

          {showSavings && (
            <div className="premium-upsell-savings">
              <TrendingUp size={16} />
              <span>
                You'd save about <strong>${savings.toFixed(2)}</strong> on this with Premium's 1% fee.
              </span>
            </div>
          )}

          <div className="premium-upsell-actions">
            <button className="rd-btn rd-btn-secondary" onClick={onClose}>
              Not now
            </button>
            <button className="rd-btn rd-btn-purple" onClick={handleUpgrade}>
              Upgrade to Premium
            </button>
          </div>

          <p className="premium-upsell-foot">$49/mo · cancel anytime · no credit card to stay on Free.</p>
        </div>
      </div>

      <style>{`
        .premium-upsell-modal { max-width: 460px; width: 100%; }
        .premium-upsell-lead { font-size: 14px; color: var(--ink-secondary, #4b5563); margin-bottom: 16px; line-height: 1.5; }
        .premium-upsell-feats { list-style: none; padding: 0; margin: 0 0 16px; display: flex; flex-direction: column; gap: 10px; }
        .premium-upsell-feats li { display: flex; align-items: flex-start; gap: 8px; font-size: 14px; color: var(--ink-secondary, #4b5563); line-height: 1.4; }
        .premium-upsell-feats li svg { color: var(--ok, #16a34a); flex-shrink: 0; margin-top: 2px; }
        .premium-upsell-savings {
          display: flex; align-items: center; gap: 8px;
          background: var(--brand-100, rgba(124, 58, 237, 0.08));
          border: 1px solid var(--brand-200, rgba(124, 58, 237, 0.25));
          color: var(--ink, #1f2937);
          border-radius: var(--r-md, 8px);
          padding: 10px 12px; font-size: 13px; margin-bottom: 18px;
        }
        .premium-upsell-savings svg { color: var(--brand-600, #7c3aed); flex-shrink: 0; }
        .premium-upsell-actions { display: flex; gap: 10px; }
        .premium-upsell-actions .rd-btn { flex: 1; justify-content: center; min-height: 44px; }
        .premium-upsell-foot { text-align: center; font-size: 12px; color: var(--ink-muted, #9ca3af); margin-top: 14px; }
        @media (max-width: 480px) {
          .premium-upsell-actions { flex-direction: column-reverse; }
        }
      `}</style>
    </div>
  );
};

export default PremiumUpsellModal;
